// typings

import { create } from "zustand";

import { IManageClientState } from "@/store-zustand/modelos/index";

// criação da store com Zustand (Fixas Tecnicas)
export const useStoreZustandModelos = create<IManageClientState>((set) => ({
  // estados
  isLoading: false,
  isLoadingPage: false,
  modelos: [],
  paginations: [1],
  itemsPerPage: 10,
  currentPage: 1,
  totalItemsPage: 0,
  searchItem: "",
  lastPage: 1,
  isModalInativarModelo: false,
  isModalReativarModelo: false,
  modeloUnico: null,

  // ações
  setIsLoading: (isLoading) => set({ isLoading }),
  setItemsPerPage: (itemsPerPage) => set({ itemsPerPage }),
  setCurrentPage: (currentPage) => set({ currentPage }),
  setTotalItemsPage: (totalItemsPage) => set({ totalItemsPage }),
  setModelos: (modelos) => set({ modelos }),
  setSearchItem: (searchItem) => set({ searchItem }),
  setIsLoadingPage: (isLoadingPage) => set({ isLoadingPage }),
  setLastPage: (lastPage) => set({ lastPage }),
  setPaginations: (paginations) => set({ paginations }),
  setIsModalInativarModelo: (isModalInativarModelo) => set({ isModalInativarModelo }),
  setIsModalReativarModelo: (isModalReativarModelo) => set({ isModalReativarModelo }),
  setModeloUnico: (modeloUnico) => set({ modeloUnico }),
}));
